export default "__VITE_ASSET__Dy0Xvz_Z__"